import { FormControlSizes, Toggle, Tooltip } from '@talos/kyoko';

interface IncludeOpenCareOrdersOutsideDateRangeToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

export function IncludeOpenCareOrdersOutsideDateRangeToggle({
  checked,
  onChange,
}: IncludeOpenCareOrdersOutsideDateRangeToggleProps) {
  return (
    <Tooltip tooltip="When enabled, will include all open orders that fall outside of the selected date lookback period. Only applies if a lookback is provided (e.g. Past week), and not if a specific date range is provided (e.g. Aug 21st to Aug 24th).">
      <Toggle
        size={FormControlSizes.Small}
        checked={checked}
        onChange={onChange}
        label="Include All Open Orders"
        data-testid="include-open-care-orders-outside-date-range-toggle"
      />
    </Tooltip>
  );
}
